export const logros = [
  {
    titulo: "Taller de Periodismo",
    descripcion:
      "Ganadores en el año 2000 con el 'Taller de Periodismo Televisivo y Radial', el cual permanece exitosamente hasta la actualidad.",
    tipo: "Académico",
  },
  {
    titulo: "Puentes con Iberoamérica",
    descripcion:
      "Proyecto de Innovación Escolar Transnacional que fortaleció vínculos pedagógicos internacionales.",
    tipo: "Académico",
  },
  {
    titulo: "Tratamiento del Agua",
    descripcion:
      "Ganadores del III Concurso de Innovaciones Pedagógicas (2002) con el proyecto 'Tratamiento del Agua para mejorar la calidad de vida'.",
    tipo: "Científico",
  },
  {
    titulo: "Aprendizaje Interactivo",
    descripcion:
      "Ganadores del IV Concurso de Innovaciones Pedagógicas (2003) con el proyecto 'Desarrollo del Aprendizaje Interactivo'.",
    tipo: "Científico",
  },
  {
    titulo: "Profesor CD-ROM",
    descripcion:
      "Ganadores del concurso regional FENCYT (2004) con participación nacional en el área de Informática.",
    tipo: "Tecnológico",
  },
  {
    titulo: "Oratoria Regional",
    descripcion:
      "Primer puesto en el concurso Regional de Oratoria (2004) con la participación de Elena Aguilar Gonzáles.",
    tipo: "Cultural",
  },
  {
    titulo: "Conociendo mejor mi Región",
    descripcion:
      "Ganadores del concurso regional (2005) con la participación de Mayra Vásquez Cauper.",
    tipo: "Cultural",
  },
  {
    titulo: "Concurso de Pintura",
    descripcion:
      "Primer puesto en pintura (2008) con la participación de Carlos Díaz Amaringo.",
    tipo: "Artístico",
  },
  {
    titulo: "Olimpiadas de Matemática",
    descripcion:
      "Medalla de Oro (2010) con la participación de la alumna Mayra Mavila Dávila.",
    tipo: "Académico",
  },
  {
    titulo: "Vóley Femenino Pentacampeón",
    descripcion:
      "Destacada participación nacional, pentacampeonas en vóley femenino representando a la región.",
    tipo: "Deportivo",
  },
  {
    titulo: "Campeones Nacionales de Vóley Masculino",
    descripcion:
      "En 2002 el equipo de varones fue campeón nacional y participó en el Torneo Sudamericano en Talca, Chile.",
    tipo: "Deportivo",
  },
];
